<template>
    <div class="innerBox">
  
      <h1>Own Risk</h1>
  
      <panel class="border border-secondary" :noExpand="true">
        <template slot="header">
          <h4 class="panel-title">Filter</h4>
        </template>
        <div class="row outerBox filterBox">
          <div class="col row">
            <!-- <div class="col-md-4" :class="mobile ? 'pt-20' : ''">
              <label for="partshopCode">Cari</label>
              <input type="text" class="form-control" placeholder="Ketik teks" style="height: 43px;" v-model="filter.search">
            </div> -->
            <div class="col-md-3" :class="mobile ? 'pt-20' : ''">
              <label for="partshopCode">Perusahaan Asuransi</label>
              <!-- <input type="text" class="form-control" placeholder="Ketik teks" style="height: 43px;" v-model="filter.search"> -->
              <Multiselect 
                v-if="insuranceCompany"
                :options="insuranceCompany.map(x => x.id)"
              :custom-label="opt => insuranceCompany.find(x => x.id == opt).name"
              v-model="filter.insurance"
              />
            </div>
            <div class="col-md-3" :class="mobile ? 'pt-20' : ''">
              <label for="partshopCode">Status Pembayaran</label>
              <!-- <input type="text" class="form-control" placeholder="Ketik teks" style="height: 43px;" v-model="filter.search"> -->
              <Multiselect 
                :options="filterOptions.status_pembayaran.map(x => x.variable)"
                :custom-label="opt => filterOptions.status_pembayaran.find(x => x.variable == opt).label"
                v-model="filter.paid"
              />
            </div>
            <div class="col-md-3" :class="mobile ? 'pt-20' : ''">
              <label for="partshopCode">Tanggal</label>
              <flat-pickr
                v-model="selected.date"
                :config="rangeConfig"
                placeholder="Pilih Tanggal"
              ></flat-pickr>
            </div>
            
            
            <div class="col-md-3" style="display: flex; flex-direction: column-reverse" :class="mobile ? 'pt-20' : ''">
              <button type="button" class="btn btn-primary" style="height:38px; margin-bottom:0.5%" @click="updateFilter">Filter</button>
            </div>
          </div>
        </div>
      </panel>

		<div class="row mt-2 mb-2">
			<div class="col-md-4">
				<stats
					title="Total Keseluruhan"
					:value="total ? 'Rp. ' + numberWithCommas(parseFloat(total.total_paid) + parseFloat(total.total_unpaid)) : 'Loading...'"
					:sub_value="total ?  numberWithCommas(parseFloat(total.total_paid_count) + parseFloat(total.total_unpaid_count)) : 'Loading...'"
					icon="money-check"
					background_color="#FF5B57"
				></stats>
			</div>
			<div class="col-md-4">
				<stats
					title="Total Lunas"
					:value="total ? 'Rp. ' + numberWithCommas(total.total_paid) : 'Loading...'"
					:sub_value="total ?  numberWithCommas(parseFloat(total.total_paid_count)) : 'Loading...'"
					icon="money-bill-wave-alt"
					background_color="#49B6D6"
				></stats>
			</div>
			<div class="col-md-4">
				<stats
					title="Total Belum Lunas"
					:value="total ? 'Rp. ' + numberWithCommas(total.total_unpaid) : 'Loading...'"
					:sub_value="total ?  numberWithCommas(parseFloat(total.total_unpaid_count)) : 'Loading...'"
					icon="file"
					background_color="#F59C19"
				></stats>
			</div>
		</div>
  
      <vue-universal-table
        api_url="/api/v1/own-risk"
        :fields="vue_universal_table.fields"
        :special_buttons="vue_universal_table.special_buttons"
        :disable_sort="true"
        :update="vue_universal_table.update"
        :filter="filter"
        :export_config="vue_universal_table.export_config"
      ></vue-universal-table>
  
    </div>
  </template>
  
  <script>  
    import Multiselect from 'vue-multiselect'
    import moment from 'moment'
	import Stats from './children/smallStats'
    export default {
      components : {
        Multiselect,
		Stats
      },
      data () {
        let start = moment().subtract(4 , 'months').startOf('month').format('YYYY-MM-DD');
        let end  = new moment().endOf('month').format('YYYY-MM-DD')
        let filter = {}
        if(!this.$route.query.start) {
          filter = {
            search : '',
            insurance : null,
            paid : null,
            start : start,
            end : end
          }

          history.pushState({},
            null,
            this.$route.path +
            '?' +
            Object.keys(filter)
              .map(key => {
              return (
                encodeURIComponent(key) + '=' + encodeURIComponent(filter[key])
              )
              })
              .join('&')
          )
        }
        else {
          let obj = this.$route.query
          console.log(obj)
          // obj.forEach(element => {
          // 	if(obj[element] == 'null') obj[element] = null
          // });
          for(let key in obj) {
            if(obj[key] == 'null') obj[key] = null
          }
          filter = obj
          start = new moment(obj.start).format('YYYY-MM-DD')
          end = new moment(obj.end).format('YYYY-MM-DD')
          
        }
        return {
          mobile : this.isMobile(),
          insuranceCompany : null,
          modal : {
            view : false,
          },
          rangeConfig: {
            mode: 'range',
            altInput: true,
            altInputClass: 'form-control input flatpickr-input w-100',
            animate: !this.isRTL()
          },
          detailId : '',
          selected : {
            date : `${start} to ${end}`,
          },
          filter : filter,
          filterOptions : {
					status_pembayaran : [{
              label : 'Lunas',
              variable : 1
            }, {
              label : 'Belum Lunas',
              variable : 0
            }]
          },
          total : null,
          vue_universal_table : {
            fields : [
                {
                    title : 'Work Order ID',
                    variable : 'work_order_code'
                },
                {
                    title : 'Nomor Polisi Mobil',
                    variable : 'no_pol'
                },
                {
                    title : 'Nama Pelanggan',
                    variable : 'customer_name'
                },
                {
                    title : 'Asuransi',
                    variable : 'insurance_name'
                },
                /*{
                    title : 'Jumlah Sparepart',
                    variable : 'sparepart_quantity',
                    number_formatting : true
                },*/
                {
                    title : 'Harga Total',
                    variable : 'total_price',
                    number_formatting : true
                },
                {
                    title : 'Tanggal Pembayaran',
                    variable : 'payment_date',
                    date_format : 'MMM DD, Y HH:mm'
                }
            ],
            special_buttons : ['exportToExcel'],
            update : 0,
            export_config : {
              name : 'Own Risk',
              type : 'xlsx',
              all : true
            },
          },
          dummyData : null,
        }
      },
      mounted () {
        this.generateData()
        this.getListOfInsuranceCompany()
      },
      watch : {
        'selected.date'(){
          var date = this.selected.date.split(" to ");
          this.filter.start = date[0]
          this.filter.end = date[1]
        },
        'vue_universal_table.update' : function() {
          this.generateData()
        }
      },
      methods : {
        updateFilter() {
          this.updateHistory()
          this.vue_universal_table.update++
        },
        updatePage (page) {
          this.filter.page = page
          this.updateHistory()
          
        },
        updateHistory () {
          history.pushState({},
            null,
            this.$route.path +
            '?' +
            Object.keys(this.filter)
              .map(key => {
              return (
                encodeURIComponent(key) + '=' + encodeURIComponent(this.filter[key])
              )
              })
              .join('&')
          )
        },
        viewDetail(a){
          console.log(JSON.parse(a).form_code);
          this.detailId = JSON.parse(a).form_code;
          this.modal.view = true;
        },
        async generateData(){
            let qs = await this.initialiseFilter(this.filter)
            console.log(qs)
            this.$http.get('/api/v1/own-risk/total' + qs)
            .then((resp) => {
              this.total = resp.data.data[0]
            })
            .catch((err) => {
              console.log(err)
            })
        },
        initialiseFilter(filter){
          var keys = Object.keys(filter);
          let stringUrl = '?';
          var queryParams = filter;

          for(var i = 0 ; i < keys.length; i++){
            if(typeof queryParams[keys[i]] == 'number');
            else if (!queryParams[keys[i]])
              continue;
            else if(queryParams[keys[i]] == '' || (Array.isArray(queryParams[keys[i]]) && queryParams[keys[i]].length == 0))
              continue 

            if((keys[i] == 'user_type') && queryParams[keys[i]] == 'All')
              continue;
            
            // if(keys[i] == 'start_hour' || keys[i] == 'end_hour')
            //   queryParams[keys[i]] += ":00";
            
            if([keys[i]] == 'start' || keys[i] == 'end') queryParams[keys[i]] = moment(queryParams[keys[i]]).format('Y-MM-DD')
            

            stringUrl += `&${keys[i]}=${queryParams[keys[i]]}`;
            
          }
          return stringUrl;
        },
        getListOfInsuranceCompany () {
          this.insuranceCompany = null;

          this.$http.get('/api/v1/insurance/company?pagination=false')
          .then((resp) => {
            this.insuranceCompany = resp.data.data
            // console.log(this.woList)
          })
          .catch((err) => { console.log(err) })
        },
      }
    }
  </script>
  
  <style scoped>
  
  </style>